import { PlayerProfileFragment } from 'generated/spin-graphql';
import React from 'react';
import { PlayerProfile } from './PlayerProfile';

export function PlayerProfileContainer({ player }: { player: PlayerProfileFragment }) {
    return (
        <div className="container player-profile-container">
            <PlayerProfile player={player} />
        </div>
    );
}
